const input = document.querySelector("#CustomerFormPhone");
const createCustomerForm = document.forms["create_customer"];
const errorMsg = document.querySelector("#error-phone-msg");

// initialise plugin
const createCustomer_iti = window.intlTelInput(input, {
// autoInsertDialCode: true,
formatOnDisplay: false,  
nationalMode: false,
initialCountry: "auto",
preferredCountries: ["fr"],
geoIpLookup: callback => {
    fetch("https://ipapi.co/json")
    .then(res => res.json())
    .then(data => callback(data.country_code))
    .catch(() => callback("fr"));
},
utilsScript: "//majouri.com/cdn/shop/t/167/assets/intlTelInputUtils.min.js?v=107170978870938937911790837366"
});

const reset = () => {
input.classList.remove("is-invalid");
input.classList.remove("is-valid");
errorMsg.innerHTML = "";
errorMsg.classList.add("d-none");
errorMsg.classList.remove("d-block");
};

const validatePhone = (ev) => {
reset();
if (input.value.trim()) {
    if (createCustomer_iti.isValidNumber()) {
    input.classList.remove("is-invalid");
    input.classList.add("is-valid");
    createCustomer_iti.setNumber(createCustomer_iti.getNumber());
    return true
    } else {
    input.classList.remove("is-valid");
    input.classList.add("is-invalid");
    errorMsg.innerHTML = "Invalid number";
    errorMsg.classList.remove("d-none");
    errorMsg.classList.add("d-block");
    return false
    }
}
return true
}

const validateForm = (ev) => {
var isPhoneValid = validatePhone();
if(! isPhoneValid) { ev.preventDefault(); }
}

// on submit: validate form 
window.onload = (evt) => {
createCustomerForm.addEventListener('submit', validateForm);
};

// on blur: validate
input.addEventListener('blur', validatePhone);

// on input flag: reset
input.addEventListener('input', reset);